<script lang="ts">
  import { Col, Container, Row } from "sveltestrap";
  import BookmarkTimeLine1 from "./BookmarkTimeLine.svelte";
  import Card from "../../Core/Card.svelte";
  import { Example } from "../../../utils/Constant/Constant";
  import data from "../../../Data/BonusUi/BonusUi.json"
  import {
            Timeline,
            TimelineItem,
            TimelineSeparator,
            TimelineDot,
            TimelineConnector,
            TimelineContent,
            TimelineOppositeContent
        } from 'svelte-vertical-timeline';

</script>
<BookmarkTimeLine1 />
<Container fluid >
    <Row>
      <Col sm="12">
        <Card cardHeaderprops="pb-0" headerTitle={Example}>
          <div slot="contentbody">
            <Timeline position="alternate">
                {#each data.timelinedata as timelineItem }
                    <TimelineItem >
                        <TimelineSeparator >
                            <TimelineDot >{@html timelineItem.icon}</TimelineDot>
                            <TimelineConnector />
                        </TimelineSeparator>
                        <TimelineContent >
                            {@html timelineItem.content}
                        </TimelineContent>
                        <TimelineOppositeContent slot="opposite-content">
                            <span class="cd-date">Jan <span class="counter digits">{timelineItem.date}</span></span>
                        </TimelineOppositeContent>
                    </TimelineItem>
                {/each}
            </Timeline>
          </div>
        </Card>
      </Col>
    </Row>
</Container>